
/* --------------------------------------------------
	Document Ready
*/
(function($) {

	$(document).ready(function(){

		var $nav = $('.header .gnav .menu ul li a');
		var url = location.pathname.split('/');
		var index = -1;
		if ($('body').hasClass('home')) {
			// ホーム
			index = 0;
		} else if (url[1] == 'products') {
			// 仏壇・仏具
			index = 1;
		} else if (url[1] == 'memorial') {
			// お墓
			index = 2;
		} else if (url[1] == 'shop') {
			// 店舗
			index = 4;
		} else if (url[1] == 'review') {
			// 店舗
			index = 4;
		} else if (url[1] == 'learning') {
			// 法事・供養
			index = 5;
		}
		if (index >= 0) {
			$nav.eq(index).addClass('active');
		}
		console.log(location.pathname);

	});
  
     /*スクロールで表示*/
  $(window).on('load scroll', function(){
  if ($(window).scrollTop() > 200) {
   $('#fix-btn').fadeIn(400);
   } else {
    $('#fix-btn').fadeOut(400);
  }
  });

})(jQuery);